import { useEffect } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { getAccessToken } from "@/services/authService";

// Refresh tokens silently every 5 minutes to keep the session alive and detect expiration proactively
const REFRESH_INTERVAL_MS = 5 * 60 * 1000;

export const useTokenRefresh = () => {
  const isAuthenticated = useIsAuthenticated();
  const { accounts } = useMsal();

  useEffect(() => {
    if (!isAuthenticated || accounts.length === 0) return;

    const interval = setInterval(() => {
      console.debug("Attempting silent token refresh...");
      // getAccessToken already handles every failure mode (transient errors,
      // iframe timeouts, interaction-required) including escalating to an
      // interactive redirect when needed, so there's nothing left to do here.
      void getAccessToken();
    }, REFRESH_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [isAuthenticated, accounts]);
};
